import { createSxStyles } from "@common/createSxStyles";

export const useBulkAssessDialogStyles = () => {
    return createSxStyles({
        subHeader: {
            display: "flex",
            justifyContent: "center",
        },
        entityTable: {
            maxHeight: 700,
            overflowY: "auto",
        },
        scenarioTable: {
            maxHeight: 700,
            overflowY: "auto",
        },
    });
};
